import { render, staticRenderFns } from "./VersionUpdateDialog.vue?vue&type=template&id=0ee7ded5&scoped=true"
import script from "./VersionUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./VersionUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7ded5",
  null
  
)

export default component.exports